
const 	checkoutButtons = document.querySelector('.js-checkout-buttons');

let ppButton, stripeButton;

if ( checkoutButtons ) {

	ppButton = document.querySelector('.wcppec-checkout-buttons');
	stripeButton = document.querySelector('#wc-stripe-payment-request-wrapper');

	if ( stripeButton ) {
		//checkoutButtons.classList.add('checkout-button-and-logos--or-extension');
	}
}